// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IZun","select":"styles_select__2qRE2"};